import classNames from '@/utils/classNames';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styles from './CenteredPage.module.css';

interface CenteredPageProps extends HTMLAttributes<HTMLDivElement> {}

/** For centering content in alignment with the page boundaries (no padding) */
export const CenteredPage = forwardRef<HTMLDivElement, CenteredPageProps>(({ className, ...props }, ref) => {
    return <div ref={ref} className={classNames(styles.container, className)} {...props} />;
});
